import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import atlanticoVideo from '../../images/atlantico/atlantico.mp4';

function Atlantico() {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        video.play().catch(() => {});
                    } else {
                        video.pause();
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(video);

        return () => observer.disconnect();
    }, []);

    return (
        <div className="relative h-[100vh] h-[100dvh] flex items-center justify-center">
            <video
                ref={videoRef}
                loop
                muted
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
                playsInline
            >
                <source src={atlanticoVideo} type="video/mp4" />
            </video>
            <div className="relative z-10 text-white text-center">
                <h2 className="font-custom font-bold md:text-8xl text-5xl">ATLÂNTICO</h2>
                <p className="md:text-3xl text-2xl mt-8">The first solar boat with a natural fiber hull made by students</p>
                <Link
                    to="/atlantico"
                    className="w-fit px-5 py-2.5 bg-white text-slate-900 font-bold rounded-full hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom mt-8 inline-block"
                >
                    Find Out More
                </Link>
            </div>
        </div>
    );
}

export default Atlantico;
